import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"

import "flatpickr/dist/themes/material_blue.css"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Col, Row } from "reactstrap"

// Componentes
import GastosForm from "./components/GastosForm"
import GastosConsulta from "./components/GastosConsulta"
import TransferenciasForm from "./components/TransferenciasForm"
import ControlView from "./components/ControlView"

// Selectores
import {
  useAuthPermiso,
  useAuthIdPersonaAuthenticated,
  useCajaConceptosGasto,
  useCajaConceptosGastoOptions,
  useCajaConceptosGastoIsLoading,
  useCampusVirtualIdCampus,
  useCajaMensajeExitoso,
  useCajaGastos,
} from "store/selectors"

// #region actions
import { getCajaConceptosGasto, getCajaGastos } from "../../store/actions"
// #endregion

// Constantes
const hoy = new Date()
const primerDiaMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1)

const defaultOptions = []
const initialValues = {
  id_Gasto: -1,
  id_Campus: -1,
  id_Centro_Costos: -1,
  id_Concepto_Gasto: -1,
  id_Documento: -1,
  id_Forma_Pago: -1,
  Cancelado: false,
  Fecha_Creacion: hoy,
  Folio_Documento: "",
  Importe: 0.0,
  Descripcion_Persona_Autorizadora_Operacion: "",
  Descripcion_Persona_Recibo: "",
  Descripcion_Persona_Entrego_Recibo: "",
  Descripcion_Operacion: "",
}

const createOption = label => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ""),
})

const documentosOptions = [
  { value: 13, label: "Este Mismo" },
  { value: 14, label: "Nota Remisión" },
  { value: 15, label: "Factura" },
  { value: 16, label: "Recibo" },
]

const formaPagoOptions = [
  { value: 1, label: "Efectivo" },
  { value: 2, label: "Cheque" },
  { value: 3, label: "Vales" },
]

const costosOptions = [
  { value: 2, label: "Administración" },
  { value: 1, label: "Contabilidad" },
  { value: 3, label: "Extensión" },
  { value: 4, label: "Infraestructura y Mantenimiento" },
  { value: 5, label: "Investigación" },
  { value: 6, label: "Servicios Estudiantiles" },
  { value: 7, label: "Tecnología y Recursos Informáticos" },
]

// Datos Mock para Consulta de Gastos

// [
//   {
//     id_Gasto: 1,
//     Fecha_Creacion: "2024-03-01",
//     Importe: 1500,
//     Descripcion_Operacion: "Compra de insumos",
//     Descripcion_Persona_Recibo: "Juan Pérez",
//     id_Centro_Costos: "1001",
//   },
//   {
//     id_Gasto: 2,
//     Fecha_Creacion: "2024-03-02",
//     Importe: 2000,
//     Descripcion_Operacion: "Pago de servicios",
//     Descripcion_Persona_Recibo: "María López",
//     id_Centro_Costos: "1002",
//   },
// ]

const CajaChicaContainer = () => {
  const dispatch = useDispatch()

  // Estado para manejar las vistas
  const [vistaActual, setVistaActual] = useState("formulario")

  // Estado para opciones de personas
  const [optionsPersonaRecibeRecurso, setOptionsPersonaRecibeRecurso] =
    useState(defaultOptions)
  const [optionsPersonaEntregoRecurso, setOptionsPersonaEntregoRecurso] =
    useState(defaultOptions)
  const [optionsPersonaAutorizoRecurso, setOptionsPersonaAutorizoRecurso] =
    useState(defaultOptions)

  // Selectores
  const conceptosGastoOptions = useCajaConceptosGastoOptions()
  const id_Campus = useCampusVirtualIdCampus()
  const datosGastos = useCajaGastos()

  // Función para cambiar entre vistas
  const cambiarVista = vista => setVistaActual(vista)

  // Cargar opciones desde localStorage
  const cargarOpcionesDesdeStorage = (clave, setOptions) => {
    const stored = localStorage.getItem(clave)
    if (stored) {
      try {
        const storedValues = JSON.parse(stored)
        const storedOptions = storedValues.map(val => createOption(val))
        storedOptions.sort((a, b) => a.label.localeCompare(b.label))
        setOptions(storedOptions)
      } catch (e) {
        console.error(`Error al parsear los datos de ${clave}`, e)
      }
    }
  }

  // Carga de datos desde localStorage
  useEffect(() => {
    cargarOpcionesDesdeStorage(
      "CajaPersonaRecibeRecurso",
      setOptionsPersonaRecibeRecurso
    )
    cargarOpcionesDesdeStorage(
      "CajaPersonaEntregoRecurso",
      setOptionsPersonaEntregoRecurso
    )
    cargarOpcionesDesdeStorage(
      "CajaPersonaAutorizoRecurso",
      setOptionsPersonaAutorizoRecurso
    )
  }, [])

  // Carga de conceptos de gasto
  useEffect(() => {
    dispatch(
      getCajaConceptosGasto({
        nombreSolicitud: "getconceptogastos",
      })
    )
  }, [dispatch])

  const onSubmitConsulta = values => {
    console.log("onSubmitConsulta::Form data", values)
    dispatch(
      getCajaGastos({
        nombreSolicitud: "getgastos",
        idCampus: id_Campus,
        fecha_Inicial: values.Fecha_Inicio,
        fecha_final: values.Fecha_Fin,
      })
    )
  }

  return (
    <React.Fragment>
      <ToastContainer />
      <Row>
        <ControlView vistaActual={vistaActual} cambiarVista={cambiarVista} />
      </Row>
      <Row className="mt-3">
        <Col sm="12">
          {vistaActual === "formulario" && (
            <GastosForm
              modo="captura"
              initialValues={initialValues}
              isLoading={false}
              optionsPersonaRecibeRecurso={optionsPersonaRecibeRecurso}
              optionsPersonaEntregoRecurso={optionsPersonaEntregoRecurso}
              optionsPersonaAutorizoRecurso={optionsPersonaAutorizoRecurso}
              documentosOptions={documentosOptions}
              costosOptions={costosOptions}
              conceptosGastoOptions={conceptosGastoOptions || []}
              formaPagoOptions={formaPagoOptions}
            />
          )}

          {vistaActual === "consulta" && (
            <GastosConsulta gastos={datosGastos} onBuscar={onSubmitConsulta} />
          )}

          {vistaActual === "transferencias" && <TransferenciasForm />}
        </Col>
      </Row>
    </React.Fragment>
  )
}

export default CajaChicaContainer
